export default "__VITE_ASSET__Chcj$sdW__"